module.exports = __webpack_public_path__ + "img/brisbane-line.caa0e74c.svg";